import Image from 'next/image'
import { FC } from 'react'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cls from './bonus-accrued-panel.module.scss'

interface BonusAccruedPanelProps {
	count: number
	isLoading?: boolean
}

export const BonusAccruedPanel: FC<BonusAccruedPanelProps> = ({ count, isLoading }) => (
	<div className={cls.bonusAccruedPanel}>
		<p className={cls.bonusAccruedPanel__lable}>Вернётся бонусами</p>
		{isLoading && <SkeletonLoader width={50} height={15} />}
		{!isLoading && (
			<div className={cls.bonusAccruedPanel__count}>
				<Image src="/entities/Bonus/bonusLogo.png" width={15} height={15} alt="" />
				<span>{count}</span>
			</div>
		)}
	</div>
)
